export default __webpack_public_path__ + "static/media/meals_male.9ec0b4a1.png";